export default {"src":"/_next/static/media/winner_right_new.c4cda624.svg","height":182,"width":281,"blurWidth":0,"blurHeight":0};